export default defineAppConfig({
  store: {
    appStore: "https://apps.apple.com/us/app/chimege-reader/id1501713310",
    playStore:
      "https://play.google.com/store/apps/details?id=com.chimege.reader&hl=en&gl=US",
  },

  landing: {
    promo: {
      webm: "/promo/default.webm",
      youtube: "https://www.youtube.com/watch?v=vo-YF1mERvE",
      skipInterval: 5000,
    },
  },

  editor: {
    characterLimit: 1024,
    proseClasses: [
      "prose prose-sm lg:prose-base !max-w-none prose-p:mt-0 prose-p:mb-0 outline-none focus:outline-none",
      "prose-mark:bg-accent-background prose-mark:text-accent-foreground prose-mark:rounded-sm prose-mark:px-1 prose-mark:py-0.5 prose-p:focus:bg-secondary/40 prose-p:focus:shadow-sm",
    ],
    autoPlay: true,
    tools: {
      enableSimplify: false,
      enableTranslate: false,
      enableBackground: true,
    },
    defaultSpeakerIdMn: 5,
    defaultSpeakerIdEn: 7,
    defaultSpeakerMN: "female2v3",
    defaultSpeakerEN: "JBFqnCBsd6RMkjVDRZzb",
    setLastSpeakerAsDefault: true,
    lastSpeakerCookieKey: "last_speaker",
    speedAdjuster: {
      min: 0.7,
      max: 1.2,
      step: 0.1,
      default: 1.0,
    },
    emotionalSpeedAdjuster: {
      min: 0.5,
      max: 2.0,
      step: 0.1,
      default: 1.0,
    },
    pitchOptions: [
      { value: 0.5, label: "veryLow" },
      { value: 0.75, label: "low" },
      { value: 1.0, label: "normal" },
      { value: 1.25, label: "high" },
      { value: 1.5, label: "highMid" },
      { value: 1.75, label: "veryHigh" },
    ],
    defaultScenarioId: 12,
    defaultSpeed: 1.0,
    defaultPitch: 1.0,
    textDiff: {
      debounce: 600,
      resynthesizeDistance: 15,
    },
    resynthesizeLimit: 3,
    emotionalTags: [
      {
        tag: "<laugh>",
        emoji: "😂",
        desc: "app.tts.emotionalTags.laugh",
      },
      {
        tag: "<breath>",
        emoji: "😮‍💨",
        desc: "app.tts.emotionalTags.breath",
      },
      {
        tag: "<sigh>",
        emoji: "😔",
        desc: "app.tts.emotionalTags.sigh",
      },
      {
        tag: "<pause>",
        emoji: "⏸️",
        desc: "app.tts.emotionalTags.pause",
      },
      {
        tag: "<umm>",
        emoji: "🤔",
        desc: "app.tts.emotionalTags.umm",
      },
      {
        tag: "<hmm>",
        emoji: "🧐",
        desc: "app.tts.emotionalTags.hmm",
      },
      
      {
        tag: "<giggle>",
        emoji: "🤭",
        desc: "app.tts.emotionalTags.giggle",
      },
      {
        tag: "<wow>",
        emoji: "😮",
        desc: "app.tts.emotionalTags.wow",
      },
      {
        tag: "<oh>",
        emoji: "💡",
        desc: "app.tts.emotionalTags.oh",
      },
      {
        tag: "<fix_voice>",
        emoji: "🎤",
        desc: "app.tts.emotionalTags.fix_voice",
      },
    ],
  },

  shortcuts: {
    enable: true,
    shortcuts: {
      convertText: "Mod-Enter",
      editText: "Cmd+E",
      togglePlay: "Cmd+K",
    },
  },

  home: {
    greeting: {
      enable: true,
    },
    speakers: {
      enable: false,
    },
    recentlyPlayed: {
      enable: false,
    },
    collections: {
      enable: false,
    },
  },

  admin: {
    backgrounds: {
      limbe: "app.tts.background.limbe",
      jazz: "app.tts.background.jazz",
      horror: "app.tts.background.horror",
      epic: "app.tts.background.epic",
      traffic: "app.tts.background.traffic",
      birthday: "app.tts.background.birthday",
      chill: "app.tts.background.chill",
      piano: "app.tts.background.piano",
      rain: "app.tts.background.rain",
    },
    providerOptions: [
      "chimege",
      "elevenlabs",
      "vibevoice",
      "egune-tts",
      "egune-tts-short",
    ],
    modelOptions: [
      {
        model: "female1v2",
        language: "mn",
      },
      {
        model: "female2v2",
        language: "mn",
      },
      {
        model: "female3v2",
        language: "mn",
      },
      {
        model: "female4v2",
        language: "mn",
      },
      {
        model: "male1v2",
        language: "mn",
      },
      {
        model: "male2v2",
        language: "mn",
      },
      {
        model: "male3v2",
        language: "mn",
      },
      {
        model: "male4v2",
        language: "mn",
      },
      {
        model: "khulan",
        language: "mn",
      },
      {
        model: "zulaa",
        language: "mn",
      },
      {
        model: "chinguun",
        language: "mn",
      },
      {
        model: "bataa",
        language: "mn",
      },
      {
        model: "burmaa",
        language: "mn",
      },
      {
        model: "boldoo",
        language: "mn",
      },
      {
        model: "alex",
        language: "en",
      },
      {
        model: "hope",
        language: "en",
      }
    ],
  },
})
